module.exports = __webpack_public_path__ + "img/obra-landing-about_us.788429a5.png";